export default __webpack_public_path__ + "static/1266-209b2af82efcfbf2b455fe10a3fa3803.gif";